import component from './indexCatalog.vue'

export default component
